import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

/**
 * Property-scoped contacts for task assignee. On 422 (e.g. no contacts),
 * returns an empty list so the UI does not block with a modal.
 */
export const getContactsByProperty = async (propertyId) => {
  const ROUTE = urlConfig.backend.routes.contacts.getContactsByProperty;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .get(url, { params: { property_id: propertyId } })
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something went wrong. Please try again later.",
      };
    })
    .catch((error) => {
      const status = error.response?.status;
      if (status === 422) {
        return { res: { data: [] }, error_code: 1 };
      }
      const data = error.response?.data;
      if (status === 400) {
        return {
          error_code: 3,
          error_message:
            typeof data?.message === "string"
              ? data.message
              : "Something went wrong.",
        };
      }
      return {
        error_code: 3,
        error_message:
          typeof data?.message === "string"
            ? data.message
            : error.message || "Request failed",
      };
    });
};
